import '@babel/polyfill'
import 'mutationobserver-shim'
import Toaster from '@meforma/vue-toaster';
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

const app = createApp(App)
app.use(router)
app.use(store)
app.use(Toaster)

app.mount('#app')

